/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useMemo } from 'react';
import { Context as AuthContext } from 'contexts/auth';
import { Context as AlertContext } from 'contexts/alert';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Input } from 'components/formInputs/input';
import { changePassword } from 'api';

export const ProfilePasswordEdit = () => {
  const { state: auth } = useContext(AuthContext);
  const { alertController } = useContext(AlertContext);

  const schema = yup.object().shape(
    {
      password: yup
        .string()
        .required('Please enter your current password.')
        .default(''),
      newPassword: yup
        .string()
        .required('Please enter new password.')
        .default(''),
      newRepeatedPassword: yup
        .string()
        .required('Please repeat new password.')
        .oneOf([yup.ref('newPassword')], 'Passwords do not match.')
        .default(''),
    },
  );

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => {
      return schema.default();
    }, [schema]),
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const response = await changePassword({
      token: auth.token,
      password: data.password,
      newPassword: data.newPassword,
      alertController,
      companyId: auth.company?.company,
    });

    if (response) {
      alertController.success({ text: 'Pasword changed' });

      reset();
    }
  };

  const onError = (data) => console.log(data);

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)} action="#" method="POST">
      <div className="shadow sm:rounded-md sm:overflow-hidden">
        <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">Change password</h3>
          </div>

          <div className="grid grid-cols-6 gap-6">
            <div className="sm:col-span-3 col-span-6">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password*
              </label>
              <div className="mt-1  relative rounded-md shadow-sm">
                <Input
                  {...register('password')}
                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  id="password"
                  type="password"
                  errorMessage={errors?.password}
                />
              </div>
              {errors?.password && (
              <p className="mt-2 text-sm text-red-600" id="email-error">
                {errors?.password.message}
              </p>
              )}
            </div>
            <div className="sm:col-span-3 hidden sm:block" />
            <div className="sm:col-span-3 col-span-6">
              <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">
                New password*
              </label>
              <div className="mt-1  relative rounded-md shadow-sm">
                <Input
                  {...register('newPassword')}
                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  id="newPassword"
                  type="password"
                  errorMessage={errors?.newPassword}
                />
              </div>
              {errors?.newPassword && (
              <p className="mt-2 text-sm text-red-600" id="email-error">
                {errors?.newPassword.message}
              </p>
              )}
            </div>
            <div className="sm:col-span-3 hidden sm:block" />
            <div className="sm:col-span-3 col-span-6">
              <label htmlFor="newRepeatedPassword" className="block text-sm font-medium text-gray-700">
                Repeat new password*
              </label>
              <div className="mt-1  relative rounded-md shadow-sm">
                <Input
                  {...register('newRepeatedPassword')}
                  className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  id="newRepeatedPassword"
                  type="password"
                  errorMessage={errors?.newRepeatedPassword}
                />
              </div>
              {errors?.newRepeatedPassword && (
              <p className="mt-2 text-sm text-red-600" id="email-error">
                {errors?.newRepeatedPassword.message}
              </p>
              )}
            </div>
          </div>
        </div>
        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
          <button
            type="submit"
            className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Save
          </button>
        </div>
      </div>
    </form>
  );
};
